import React from 'react';
import { API } from '../config/apiConfig';

function formatTime(isoString) {
  if (!isoString) return '';
  const d = new Date(isoString);
  return d.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
}

export default function ChatBubble({ message, isMine }) {
  const readCount = message.readBy ? message.readBy.length : 1;
  const isRead = readCount > 1;

  return (
    <div className={`chat-bubble-wrapper ${isMine ? 'mine' : 'theirs'}`}>
      <div className={`chat-bubble ${isMine ? 'bubble-mine' : 'bubble-theirs'}`}>
        {message.type === 'image' ? (
          <div className="media-placeholder">
            {message.mediaUrl ? (
              <img src={`${API.baseUrl}${message.mediaUrl}`} alt="media" className="media-image" />
            ) : (
              <span>📷 Photo</span>
            )}
          </div>
        ) : message.type === 'video' ? (
          <div className="media-placeholder">
            {message.mediaUrl ? (
              <video controls className="media-video">
                <source src={`${API.baseUrl}${message.mediaUrl}`} />
              </video>
            ) : (
              <span>📹 Video</span>
            )}
          </div>
        ) : (
          <div className="bubble-text">{message.content}</div>
        )}
        <div className="bubble-meta">
          <span className="bubble-time">{formatTime(message.createdAt)}</span>
          {isMine && (
            <span className={`bubble-read ${isRead ? 'read' : ''}`}>
              {isRead ? '✓✓' : '✓'}
            </span>
          )}
        </div>
      </div>
    </div>
  );
}
